exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-5d1a9a84] .el-tabs__content{height:calc(100% - 55px)}", ""]);

// exports
